//? Library Imports ------------------------------------------------------------>
import Image from "next/image";
import { Col, Row, Avatar, Space, Typography } from "antd";

//? Assets --------------------------------------------------------------------->

//? Modules -------------------------------------------------------------------->
import "./OrderCard.scss";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import Unpaid from "@/assets/images/AccountsPage/Unpaid.svg";
import Cancelled from "@/assets/images/AccountsPage/Cancelled.svg";
import Delivered from "@/assets/images/AccountsPage/Delivered.svg";
import InProcess from "@/assets/images/AccountsPage/InProcess.svg";
import TrackOrderModal from "@/components/Homepage/TrackOrderModal/TrackOrderModal";
import { useState } from "react";

//? Redux Reducers ------------------------------------------------------------->
//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;
const defaultImage = "https://rb.gy/wi9shp";

export default function OrderCard({ count, OrderDetail, userAgent }) {
  const { isDesktop } = userAgent;
  const [OpenOrderTrackingModal, setOpenOrderTrackingModal] = useState(false);

  return (
    <Col
      className="OrderCard backgroundColor padding5 marginBottom10"
      style={{ height: "100%" }}
    >
      <Row justify="space-between" className="row width100">
        <Col span={24} className="marginBottom15">
          <Space className="flexBetween">
            <Space>
              <Avatar
                style={{
                  margin:
                    OrderDetail?.order_status !== "Cancelled" &&
                    OrderDetail?.order_status !== "Returned" &&
                    OrderDetail?.order_status !== "Delivered"
                      ? "0px"
                      : "6px 0px",
                }}
                shape="circle"
                // eslint-disable-next-line @next/next/no-img-element
                src={
                  <Image
                    src={
                      (OrderDetail?.order_status === "Dispatched" &&
                        InProcess) ||
                      (OrderDetail?.order_status === "Pending" && InProcess) ||
                      (OrderDetail?.order_status === "Cancelled" &&
                        Cancelled) ||
                      (OrderDetail?.order_status === "Returned" && InProcess) ||
                      (OrderDetail?.order_status === "Delivered" && InProcess)
                    }
                    alt={
                      OrderDetail?.order_status === "Pending"
                        ? InProcess
                        : "order status"
                    }
                    width={30}
                    height={30}
                  />
                }
              />
              <Space direction="vertical" className="gap0">
                <Text
                  style={{
                    color:
                      (OrderDetail?.order_status === "Dispatched" &&
                        "#FF8000") ||
                      (OrderDetail?.order_status === "Pending" && "#FF8000") ||
                      (OrderDetail?.order_status === "Returned" && "#979797") ||
                      (OrderDetail?.order_status === "Cancelled" &&
                        "#979797") ||
                      (OrderDetail?.order_status === "Delivered" && "#0EB36B"),
                  }}
                >
                  {(OrderDetail?.order_status === "Dispatched" &&
                    "Dispatched") ||
                    (OrderDetail?.order_status === "Pending" && "InProcess") ||
                    (OrderDetail?.order_status === "Cancelled" &&
                      "Cancelled") ||
                    (OrderDetail?.order_status === "Returned" && "Returned") ||
                    (OrderDetail?.order_status === "Delivered" && "Delivered")}
                </Text>
                {OrderDetail?.order_status !== "Cancelled" &&
                  OrderDetail?.order_status !== "Returned" &&
                  OrderDetail?.order_status !== "Delivered" && (
                    <Text style={{ color: "#333333" }}>
                      Shipment by {OrderDetail?.shipping_date}
                    </Text>
                  )}
              </Space>
            </Space>

            <Avatar
              size="small"
              shape="square"
              className="borderRadius0"
              icon={
                <Text
                  className="flexCenter"
                  style={{
                    display: "flex",
                    color: "#B7B7B7",
                    alignSelf: "baseline",
                  }}
                >
                  {count}
                </Text>
              }
            />
          </Space>
        </Col>

        <Col
          className="alignCenter ProductCount "
          style={{ overflow: "hidden" }}
        >
          <Row style={{ minHeight: "82px" }}>
            <div
              className=""
              style={{
                position: "relative",
                display: "flex",
                flexWrap: "wrap",
                width: "82px",
                height: "82px",
              }}
            >
              {OrderDetail?.images?.length > 1 ? (
                OrderDetail?.images?.map(
                  (image, index) =>
                    index <= 3 && (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          flexBasis: "50%",
                          height: "41px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "2px",
                        }}
                        className={index === 3 && "img_mask ImageCount"}
                      >
                        {image ? (
                          <img
                            // width={41}
                            height={41}
                            src={image}
                            alt="Product Image"
                            className="img_mask"
                          />
                        ) : (
                          <div
                            style={{
                              backgroundColor: "#F5F5F5",
                              height: "41px",
                              width: "41px",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Text
                              style={{
                                textAlign: "center",
                                fontSize: "9px",
                                alignSelf: "center",
                              }}
                            >
                              No Image
                            </Text>
                          </div>
                        )}
                        {index === 3 && OrderDetail?.images?.length - 4 > 0 && (
                          <Text
                            className={
                              isDesktop
                                ? "img_mask_tag"
                                : "img_mask_tag img_mask_tag_mobile"
                            }
                          >
                            +{OrderDetail?.images?.length - 4}
                          </Text>
                        )}
                      </div>
                    )
                )
              ) : (
                <div
                  style={{
                    position: "relative",
                    flexBasis: "100%",
                    height: "82px",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  {OrderDetail?.images[0] ? (
                    <img
                      // width={82}
                      height={82}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        // width:"auto"
                      }}
                      src={OrderDetail?.images[0]}
                      alt="Default Product Image"
                    />
                  ) : (
                    <div
                      style={{
                        backgroundColor: "#F5F5F5",
                        height: "82px",
                        width: "59px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Text
                        style={{
                          textAlign: "center",
                          fontSize: "9px",
                          alignSelf: "center",
                        }}
                      >
                        No Image
                      </Text>
                    </div>
                  )}
                </div>
              )}
            </div>
          </Row>
        </Col>

        <Col flex="0 0 68%">
          <Space direction="vertical" className="gap5">
            <Text className="font14Bold">
              Order Number :{OrderDetail?.name ? OrderDetail?.name : "N/A"}
            </Text>
            <Text className="font14">
              <Text>Amount : {OrderDetail?.currency} &nbsp;</Text>
              {OrderDetail?.total_price ? OrderDetail?.total_price : "N/A"}
            </Text>
            <Text>
              <Text className="font14">Qty: </Text>
              {OrderDetail?.total_quantity
                ? OrderDetail?.total_quantity
                : "N/A"}
            </Text>
          </Space>
        </Col>
      </Row>

      <Row
        style={{
          width: "100%",
          marginTop: "15px",
          justifyContent: "space-between",
        }}
      >
        {/* {OrderDetail?.order_status !== "Cancelled" &&
          OrderDetail?.order_status !== "Returned" &&
          OrderDetail?.order_status !== "Delivered" &&
          OrderDetail?.order_status !== "Dispatched" && (
            <Col flex="48%">
              <a
                target="_blank"
                href="#"
                // href={`https://alfamall.com.ginkgoretail.net/ordertracking/2345?contact=${OrderDetail?.phone}&name=${OrderDetail?.name}`}
              >
                <DynamicButton
                  name="Cancel Order"
                  style={{
                    fontSize: "12px",
                    color: "#000000",
                    borderRadius: "3px",
                  }}
                />
              </a>
            </Col>
          )} */}
        <Col
          flex={
            OrderDetail?.order_status !== "Cancelled" &&
            OrderDetail?.order_status !== "Returned" &&
            OrderDetail?.order_status !== "Delivered" &&
            OrderDetail?.order_status !== "Dispatched"
              ? "48%"
              : "100%"
          }
        >
          {/* <a
            target="_blank"
            // href="#"
            href={`https://oms.alfamall.com/ordertracking/021024025744950817?contact=${OrderDetail?.phone}&name=${OrderDetail?.name}`}
          >
            <DynamicButton
              name="Track Order"
              style={{
                fontSize: "12px",
                color: "#000000",
                borderRadius: "3px",
              }}
            />
          </a> */}
           <button
              style={{
                cursor: "pointer",
                alignItems: "center",
                display: "flex",
                background: "none",
                fontSize: "12px",
                color: "#000000",
                borderRadius: "3px",
              }}
              onClick={() => setOpenOrderTrackingModal(true)}
            >
              <Text style={{
                fontSize: "12px",
                color: "#000000",
                borderRadius: "3px",
              }}>
              Track Order
              </Text>
            </button>
        </Col>
      </Row>
      {OpenOrderTrackingModal && (
        <TrackOrderModal
          showTrackOrderModal={setOpenOrderTrackingModal}
          openTrackOrderModal={OpenOrderTrackingModal}
        />
      )}
    </Col>
  );
}
